$(window).on("load", function () {
	$("#omg3q-ld-26-sn3t-milestone .MS__sprite-milestone-btn").each(function () {
		var $btn = $(this);

		var status = "off";
		if ($btn.hasClass("received")) {
			status = "received";
		} else if ($btn.hasClass("active")) {
			status = "active";
		}

		var text = $btn.attr("data-" + status);
		if (text) {
			$btn.text(text);
		}
	});
});
